import type { MessagingSendMessage201AllOfBasicInfoAllOfTwoType } from './messagingSendMessage201AllOfBasicInfoAllOfTwoType';

/**
 * 메시지 기본 정보
 */
export type MessagingSendMessage201AllOfBasicInfoAllOfTwo = {
  content?: string;
  type?: MessagingSendMessage201AllOfBasicInfoAllOfTwoType;
};
